import { useEffect } from 'react'

export function useNoIndex() {
  useEffect(() => {
    const meta = document.createElement('meta')
    meta.name = 'robots'
    meta.content = 'noindex, follow'
    document.head.appendChild(meta)
    return () => { document.head.removeChild(meta) }
  }, [])
}
